<template>
    <div id="FooterBox">
        <div style="width: 1100px;margin: 0 auto;">
            <div class="top">

                <div class="img">
                    <img src="@/assets/image/en.png">
                </div>
                <div class="childer">
                    <div class="title">SUBORDINATE SUBSIDIARY COMPANY</div>
                    <div v-for="(item, index) in dataList" :key="index">
                        <a :class="item.link ? 'url' : 'url1'" :href="item.link" target="_blank"> {{ item.enName }}</a>
                    </div>
                </div>

                <div class="right">
                    <div class="sub">
                        CONTACT US
                    </div>
                    <div class="tips">Add: Building F#, New Life Hub,No.2200 West Qianjin Road, Kunshan City</div>
                    <div class="tips">Telephone: 0512-57507971</div>
                    <div class="tips">Fax: 0512-57507967</div>
                    <!-- <img src="@/assets/image/map.png" class="map" /> -->
                </div>


            </div>
        </div>
        <div class="bottom">
            Copyright © 2004 - 2024 ksccid.com All Rights Reserved
        </div>
    </div>
</template>

<script>
import {
    sub
} from '@/api/apis'

export default {
    name: 'Footer',
    props: {
        num: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            dataList: [{
                name: 'Kunshan Le Cheng Real Estate Co., Ltd.',
                link: 'http://www.kslczy.cn/'
            },
            {
                name: 'Kunshan Yangcheng Lake Resort business Hotel Plaza Limited',
                link: 'http://www.fairmont.cn/yangchenglake'
            },
            {
                name: 'Kunshan Le Jian Housing Development Co., Ltd.',
                link: ''
            },
            {
                name: 'Kunshan culture and Arts Center Development Co., Ltd.',
                link: 'http://www.kscac.com/'
            },
            {
                name: 'Kunshan Chengtou Real Estate Management Co. LTD',
                link: ''
            }, {
                name: 'Kunshan city investment management co. LTD',
                link: ''
            }, {
                name: 'Kunshan South Investment Development Co., Ltd.',
                link: ''
            }, {
                name: 'Kunshan Construction Engineering Management Co., Ltd.',
                link: ''
            }, {
                name: 'Kunshantinglin garden green construction management co. LTD',
                link: 'https://www.tinglingarden.com/index.html'
            }, {
                name: 'Kunshan city ecological Forest Park Co., Ltd.',
                link: 'http://www.ksforestpark.com/'
            }, {
                name: 'Kunshan city construction green and environmental technology co. LTD',
                link: ''
            }, {
                name: 'Kunshan chengtou ancient town protection and development co. LTD',
                link: ''
            }
            ]
        }
    },
    created() {
        this.getSub()
    },
    methods: {
        goTo(e) {
            if (e.toOtherPageUrl) {
                window.location.href = e.toOtherPageUrl
                return
            }
            if (e.url === '/') {
                return
            }
            this.$router.push(e.url)
        },
        getSub() {
            let params = {
                pageNum: 1,
                pageSize: 100
            }
            sub(params).then(res => {
                console.log("获取下属子公司", res)
                this.dataList = res.data.records
            })
        }
    }
}
</script>

<style scoped lang="scss">
#FooterBox {
    // margin-top: 40px;
    background-color: #222021;

    .sub {
        color: #fff;
        font-size: 13px;
        height: 25px;
        line-height: 25px;
        text-align: left;
    }

    .tips {
        font-size: 12px;
        line-height: 25px;
        // font-family: '微软雅黑';
        color: #cecdcd;
        text-align: left;
    }

    .top {
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        position: relative;

        .img {
            width: 299px;
            height: 170px;
            border-right: 1px solid #000;
            text-align: right;
            padding-right: 12px;
            float: left;
        }

        .childer {
            text-align: left;
            margin-left: 30px;

            .title {
                color: #fff;
                font-size: 13px;
                height: 25px;
                line-height: 25px;
            }

            .url {
                font-size: 13px;
                height: 25px;
                line-height: 25px;
                color: #666;
                cursor: pointer;
            }

            .url1 {
                font-size: 13px;
                height: 25px;
                line-height: 25px;
                color: #666;
            }

            .url:hover {
                color: #E32C1A
            }
        }


        .right {
            width: 250px;
            height: 170px;
            position: relative;
            margin-left: 30px;
        }
    }



    .bottom {
        width: 100%;
        min-width: 1100px;
        height: 30px;
        background: #0d0b0c;
        text-align: center;
        line-height: 30px;
        // font-family: '微软雅黑';
        font-size: 11px;
        color: #5f5f5f;
    }

    .map {

        position: absolute;
        right: 30px;
        bottom: 0;
    }

}
</style>
